<template>
<!-- <body class="hold-transition skin-blue sidebar-mini"> -->
<div class="wrapper">
  <header v-if="!fromClub()" class="main-header">
    <a href="#/" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><b>D</b>AS</span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><b>Qooco</b>DAS</span>
    </a>
    <nav class="navbar navbar-static-top">
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img src="./user2-160x160.jpg" class="user-image" alt="User Image">
              <span class="hidden-xs">{{$auth.user().nickname}}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img src="./user2-160x160.jpg" class="img-circle" alt="User Image">

                <p>
                  {{$auth.user().nickname}} - {{$auth.user().roles[0].replace("ROLE_","")}}
                </p>
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left" v-if="$auth.check()">
                  <a href="#" class="btn btn-default btn-flat" disabled>更改密码</a>
                </div>
                <div class="pull-right" v-if="$auth.check()">
                  <a @click="logout" class="btn btn-default btn-flat">退出</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <!-- Left side column. contains the logo and sidebar -->
  <aside class="main-sidebar" :style="fromClub()?'padding-top:20px':''">
    <!-- sidebar: style can be found in sidebar.less -->
    <a v-if="fromClub()" @click="toggleSidebar" style="cursor:pointer;width:100%;height:20px;position: absolute;background:rgb(91, 155, 213);top:0;left:0;right:-30px">
      <span class="sr-only">Toggle navigation</span>
    </a>
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <div class="user-panel" v-show="!fromClub()">
        <div class="pull-left image">
          <img src="./user2-160x160.jpg" class="img-circle" alt="User Image">
        </div>
        <div class="pull-left info">
          <p>{{$auth.user().nickname}}</p>
          <a href="#"><i class="fa fa-circle text-success"></i> Online</a>
        </div>
      </div>

      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul v-if="$auth.ready()" class="sidebar-menu" data-widget="tree">
        <li class="header" v-show="!fromClub()">功能菜单</li>
        <template v-for="item in filteredRouter">
          <li class="treeview" v-if="item.children" :key="item.alias">
            <a href="#">
              <i class="fa fa-folder"></i> <span>{{item.alias}}</span>
              <span class="pull-right-container">
                <i class="fa fa-angle-left pull-right"></i>
              </span>
            </a>
            <ul class="treeview-menu">
              <router-link tag="li" :to="child.path" :key="child.alias" v-for="child in item.children"
                v-show="!child.hidden && (!child.meta || ($auth.check(child.meta.auth.roles)&&!isQooco()) || hasPermission('/das' + child.path))"
              >
                <a>
                  <i class="fa fa-circle-o text-aqua"></i>{{child.alias}}
                </a>
              </router-link>
            </ul>
          </li>

          <router-link tag="li" :to="item.path" :key="item.alias" v-if="!item.children">
            <a>
              <i class="fa fa-circle-o text-aqua"></i>
              <span>{{item.alias}}</span>
            </a>
          </router-link>
        </template>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper" :style="fromClub()?'padding-top:0':''">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div class="clearfloat"></div>
  </div>
  <!-- /.content-wrapper -->

  <footer class="main-footer" v-if="!fromClub()">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.0.0
    </div>
    <strong>Copyright &copy; 2017-2018 <a href="http://www.qooco.com/">Qooco</a>.</strong> All rights
    reserved.
  </footer>
</div>
<!-- </body> -->
</template>

<script>
import $ from 'jquery'
import {objToKeyVal} from 'common/js/common-utils'
import {loadCustomers, loadOrgClasses, loadModeList} from 'api/condition'
import {mapMutations} from 'vuex'
import {fromClub} from 'common/js/app-utils'

export default{
  data () {
    return {
      loaded: false,
      router: []
    }
  },
  computed: {
    filteredRouter () { // 巧口角色ROLE_QOOCO需要走权限hasPermission
      var router = this.router && this.router.filter(item =>
        !item.hidden &&
        ((this.$auth.check(item.meta.auth.roles) && !this.isQooco()) ||
         this.hasPermission('/das/' + item.name)))
      // console.log('----filtered-router------------->')
      // console.log(router)
      return router
    }
  },
  mounted () {
    // window
    if (fromClub()) {
      $.getScript('http://club.qooco.com/das/sessionId', () => {
        if (localStorage.getItem('lastClubSessionId') && localStorage.getItem('lastClubSessionId') !== window.sessionId) {
          this.logout()
        } else {
          if (document.body.height === 0) {
            window.location.reload()
          }
        }
      })
    }
    this.$nextTick(function () {
      window.AdminLTE()
    })
    $('body').resize()
    this.router = this.$router.options.routes
    // state setting
    this._setCustomers()
    this._setPickerOptions()
    this._setOrgTypes()
    this._setOrgClasses()
    this._setModeList()
  },
  methods: {
    toggleSidebar () {
      $('body').toggleClass('sidebar-collapse')
    },
    isQooco () {
      return this.$auth.user().roles.indexOf('ROLE_QOOCO') !== -1
    },
    hasPermission (permission) {
      // console.log('this.$auth.user()---->')
      // console.log(this.$auth.user())
      return this.isQooco() && this.$auth.user().permissions.indexOf(permission) !== -1
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        success () {
          console.log('success')
          location.reload()
        },
        error () {
          console.log('error')
        }
      })
    },
    _setCustomers () {
      loadCustomers()
      .then((res) => {
        res.forEach((_scoo) => {
          _scoo.name = _scoo.name + ` [${_scoo.id}]`
        })
        let user = this.$auth.watch.data
        if (user.orgType === 'all') {
          this.setCustomers(res)
        } else {
          let _schools = []
          res.forEach((customer) => {
            if (user.schools.includes(customer['id'])) {
              _schools.push(customer)
            }
          })
          this.setCustomers(_schools)
        }
      }, (msg) => {
        this.$message.error(msg)
      })
    },
    _setPickerOptions () {
      let pickerOptions = {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        firstDayOfWeek: 7,
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
      this.setPickerOptions(pickerOptions)
    },
    _setOrgTypes () {
      let orgTypes = [{id: 'school', name: '学校'},
                    {id: 'hotel', name: '酒店'},
                    {id: 'club', name: '巧口语吧'},
                    {id: 'all', name: '全部'}]
      this.setOrgTypes(orgTypes)
    },
    _setOrgClasses () {
      let orgClasses = []
      loadOrgClasses()
      .then((res) => {
        let user = this.$auth.watch.data
        if (user.orgType === 'all') {
          this.setOrgClasses(orgClasses)
        } else {
          res.forEach((school) => {
            let classes = []
            school.classes.forEach((clazz) => {
              let _clazz = {value: clazz.classid, label: clazz.name}
              classes.push(_clazz)
            })
            let _school = {value: school.orgid, label: school.name, children: classes}
            orgClasses.push(_school)
          })
          this.setOrgClasses(orgClasses)
        }
      }, (msg) => {
        this.setOrgClasses([])
        this.$message.error(msg)
      })
    },
    _setModeList () {
      loadModeList()
      .then((res) => {
        // console.log(objToKeyVal(res))
        this.setModeList(objToKeyVal(res))
      })
    },
    ...mapMutations({
      setCustomers: 'SET_CUSTOMERS',
      setPickerOptions: 'SET_PICKER_OPTIONS',
      setOrgTypes: 'SET_ORG_TYPES',
      setOrgClasses: 'SET_ORG_CLASSES',
      setModeList: 'SET_MODE_LIST'
    })
  }
}
</script>

<style lang="stylus" scoped>
  .clearfloat
    clear both
    height 0
    font-size 1px
    line-height 0px
  .main-footer
    height: 50px
  .fa-folder+span
    font-size: 16px
</style>



// WEBPACK FOOTER //
// src/components/sys/home/home.vue